import pbfe from "./pbfe.js"
import { _ } from "./i18n.js";
import createNavbar from "./navbar.js";
import { getLang, LANG_URL_MAP } from "./index.js";

var container, box;
var subtitleElement, descriptionElement, homeButton;

function init(_container) {
    container = _container;

    box = new pbfe.Flexbox("column");
    box.element.id = "notFoundScreen";
    box.justifyContent = "center";
    box.alignItems = "center";
    box.element.style.height = "100vh";
    box.element.style.width = "100%";
    box.element.style.display = "none";

    // Navbar
    var navbar = createNavbar();
    box.appendChild(navbar);

    var contentBox = new pbfe.Flexbox("column");
    contentBox.alignItems = "center";
    contentBox.justifyContent = "center";
    contentBox.gap = "1.5rem";
    contentBox.element.style.flex = "1";
    contentBox.element.style.textAlign = "center";
    contentBox.element.style.padding = "1rem";

    var title = document.createElement("h1");
    title.innerText = "404";
    title.style.fontSize = "6rem";
    title.style.margin = "0";
    title.style.lineHeight = "1";
    title.style.color = "var(--primary-color)";
    contentBox.appendChild({ element: title });

    subtitleElement = document.createElement("h2");
    subtitleElement.innerText = _("Page Not Found");
    subtitleElement.style.fontSize = "2rem";
    subtitleElement.style.margin = "0";
    contentBox.appendChild({ element: subtitleElement });

    descriptionElement = new pbfe.Label(_("The page you are looking for does not exist."));
    descriptionElement.element.style.fontSize = "1.2rem";
    descriptionElement.element.style.opacity = "0.8";
    contentBox.appendChild(descriptionElement);

    homeButton = new pbfe.Button(_("Go Home"), "primary");
    homeButton.addEventListener("click", function() {
        var lang = getLang();
        var prefix = LANG_URL_MAP[lang];
        var rootPath = prefix ? "/" + prefix : "/";
        history.pushState(null, "", rootPath);
        window.dispatchEvent(new Event('popstate'));
    });
    contentBox.appendChild(homeButton);

    box.appendChild(contentBox);
    container.appendChild(box);
}

function show() {
    if (box) {
        // Update translations
        if (subtitleElement) subtitleElement.innerText = _("Page Not Found");
        if (descriptionElement) descriptionElement.element.innerText = _("The page you are looking for does not exist.");
        if (homeButton) homeButton.element.innerText = _("Go Home");

        box.element.style.display = "flex";
        
        // Add noindex tag
        var meta = document.querySelector("meta[name='robots']");
        if (!meta) {
            meta = document.createElement("meta");
            meta.name = "robots";
            document.head.appendChild(meta);
        }
        meta.content = "noindex";
        
        document.title = "404 - " + _("Page Not Found");
    }
}

function hide() {
    if (box) {
        box.element.style.display = "none";
        
        // Reset robots tag to allow indexing
        var meta = document.querySelector("meta[name='robots']");
        if (meta) {
            meta.content = "index, follow";
        }
    }
}

export default {
    init,
    show,
    hide
};
